/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TrainingPaymentMode {
    Weekly = 'WEEKLY',
    Monthly = 'MONTHLY',
    Yearly = 'YEARLY',
    EveryOccasion = 'EVERY_OCCASION'
}


export function instanceOfTrainingPaymentMode(value: any): boolean {
    for (const key in TrainingPaymentMode) {
        if (Object.prototype.hasOwnProperty.call(TrainingPaymentMode, key)) {
            if (TrainingPaymentMode[key as keyof typeof TrainingPaymentMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TrainingPaymentModeFromJSON(json: any): TrainingPaymentMode {
    return TrainingPaymentModeFromJSONTyped(json, false);
}

export function TrainingPaymentModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingPaymentMode {
    return json as TrainingPaymentMode;
}

export function TrainingPaymentModeToJSON(value?: TrainingPaymentMode | null): any {
    return value as any;
}

export function TrainingPaymentModeToJSONTyped(value: any, ignoreDiscriminator: boolean): TrainingPaymentMode {
    return value as TrainingPaymentMode;
}

